// dashboard/src/services/apiKeyService.ts
import { supabase } from './supabase';

export interface ApiKey {
  id: string;
  key_name: string;
  is_active: boolean;
  created_at: string;
  last_used_at: string | null;
}

export interface ApiKeyCreateResponse {
  api_key: string;
  key_id: string;
  message: string;
}

export const createApiKey = async (keyName?: string): Promise<ApiKeyCreateResponse> => {
  const { data: sessionData } = await supabase.auth.getSession();
  
  if (!sessionData.session) {
    throw new Error('Not authenticated');
  }
  
  const response = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-api-key`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionData.session.access_token}`,
      },
      body: JSON.stringify({ key_name: keyName }),
    }
  );
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to create API key');
  }
  
  return response.json();
};

export const listApiKeys = async (): Promise<ApiKey[]> => {
  const { data: sessionData } = await supabase.auth.getSession();
  
  if (!sessionData.session) {
    throw new Error('Not authenticated');
  }
  
  const response = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/list-api-keys`,
    {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${sessionData.session.access_token}`,
      },
    }
  );
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to list API keys');
  }
  
  const data = await response.json();
  return data.api_keys;
};

export const revokeApiKey = async (keyId: string): Promise<void> => {
  const { data: sessionData } = await supabase.auth.getSession();
  
  if (!sessionData.session) {
    throw new Error('Not authenticated');
  }
  
  const response = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/revoke-api-key/${keyId}`,
    {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${sessionData.session.access_token}`,
      },
    }
  );
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to revoke API key');
  }
};
